import React, { ComponentProps } from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetTeamSchedule } from "widgets";

import { WATeamSchedulePreviewQuery } from "./__generated__/WATeamSchedulePreviewQuery.graphql";
import { DateTime } from "luxon";

type Props = {
  query: PreloadedQuery<WATeamSchedulePreviewQuery>;
  size?: ComponentProps<typeof WidgetTeamSchedule>["forceSize"];
};

export const WATEAM_SCHEDULE_PREVIEW_QUERY = graphql`
  query WATeamSchedulePreviewQuery(
    $input: PreviewWidgetTeamScheduleInput!
    $storecastId: ID!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetTeamSchedule(input: $input) {
        ...WidgetTeamSchedule_widget
      }
    }
  }
`;
export function WATeamSchedulePreview(props: Props) {
  const data = usePreloadedQuery<WATeamSchedulePreviewQuery>(
    WATEAM_SCHEDULE_PREVIEW_QUERY,
    props.query
  );

  const now = DateTime.now();

  return (
    <WidgetTeamSchedule
      mode="IDLE"
      interactive={false}
      widget={data.dashboard.previewWidgetTeamSchedule}
      now={now}
      forceSize={props.size}
    />
  );
}
